import { Schema } from 'effect';

/**
 * How a parameter got the value it has, as the engine names them.
 *
 * `default` is the value the model brought with it and nobody has touched, `override` one the user has chosen instead, and `pending` one the engine has yet to settle. Three words the UI can act on — a parameter the user has changed is worth showing as changed — which is why they are checked rather than carried along
 * as whatever the engine wrote.
 *
 * Its own file for the same reason {@link SideTypes} has one, and the reason is not that the list is long: three words against seventeen sides and two hundred components. What the four have in common is where they come from — each is a list the engine publishes and we copy, so each is a list that can drift, and a copy
 * that is meant to fail when it does.
 */
export const ParameterStateTypes = Schema.Literals(['default', 'override', 'pending']);

/** How a parameter got the value it has. */
export type IParameterStateType = typeof ParameterStateTypes.Type;
